/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceCheckinRequest } from '../../models/voice-checkin-request';
import { VoiceCheckinResponse } from '../../models/voice-checkin-response';

export interface StartVoiceSessionCheckin$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
      body: VoiceCheckinRequest
}

export function startVoiceSessionCheckin(http: HttpClient, rootUrl: string, params: StartVoiceSessionCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<VoiceCheckinResponse>> {
  const rb = new RequestBuilder(rootUrl, startVoiceSessionCheckin.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoiceCheckinResponse>;
    })
  );
}

startVoiceSessionCheckin.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/checkin';
